export class Basic  {
    constructor(data: any) {
        // console.log(data);
    }
}
